module.exports = __webpack_public_path__ + "static/media/c19.98299540.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cruise/c19.jpg
// module id = 401
// module chunks = 0